<template>
    <div>
        <div class="dropdown-menu dropdown-tasks-holder" v-el:dropdown v-if="visible" :style="getStyle()">
            <div class="notification-header">Tarefas</div>
            <div v-if="loading" class="text-center text-muted" style="padding: 40px">
                Carregando...
            </div>
            <div v-if="!loading && !hasTasks" class="text-center text-muted" style="padding: 40px">
                Não há tarefas.
            </div>
            <div v-slimscroll :height="400" :always="false" v-if="!loading && hasTasks">
                <ul class="dropdown-tasks">
                    <li v-for="task in tasks">
                        <x-task :task.sync="task" :task-status-changed="taskStatuschanged" :close-dropdown="closeDropdown" :done="taskButtonClicked"></x-task>
                    </li>
                </ul>
            </div>
        </div>
        <property-info-handler v-ref:property-info></property-info-handler>
        <button class="btn default quick-view-customer btn-xs"
                v-quick-view-customer
                v-bind:data-id="ui.currentCustomerId"
                v-bind:data-root="'/customers/'"
                title="Visualizar"
                style="position: relative;z-index:2;border-bottom-right-radius:3px;border-top-right-radius:3px;display: none"
                v-el:view-customer-button>
            <i class="fa fa-eye"></i>
        </button>
    </div>
</template>
<style>
    .notification-header {
        font-weight: 400;
        padding: 10px 15px;
        border-bottom: 1px solid #eee;
        background-color: #00406a;
        margin-left: -1px;
        margin-right: -1px;
        color: white;
    }

    .dropdown-tasks-holder {
        position: absolute;
        left: auto;
        margin: 0;
        border-top-left-radius: 0;
        border-top-right-radius: 0;
        border: 1px solid #eee;
        border-top: 0;
    }

    .dropdown-tasks-holder .dropdown-tasks {
        list-style: none;
        padding: 0;
    }

    .dropdown-tasks-holder .dropdown-tasks > li {
        background-color: #fff;
        border-bottom: 4px solid #e0e0e0;
        padding: 0;
        margin: 0;
    }

    .dropdown-tasks-holder .dropdown-tasks > li:last-of-type {
        border-bottom: none;
    }
</style>
<script>
    const R = require('ramda')
    const utils = require('sci/utils')
    const moment = require('moment')
    const taskCreatedSub = require('sci/subscriptions/task-created')
    const taskStatusChangedSub = require('sci/subscriptions/task-status-changed')
    const client = require('sci/helpers/queue-client')
    const XTask = require("./Task.vue")

    const { list } = require('./helpers')

    export default {
        name: 'NavbarDropdownPopup',
        components: {
            XTask
        },
        props: {
            visibilityChanged: {
                type: Function
            },
            hasNewChanged: {
                type: Function
            },
            hasNewDone: {
                type: Function
            },
            hasNewRunning: {
                type: Function
            }
        },
        init () {
            this.$newEl = null;
            this.$taskCreatedEventSubscription = null;
            this.$taskStatusChangedEventSubscription = null;
        },
        data: () => ({
            loading: false,
            tasks: [],
            visible: false,
            top: 0,
            right: 0,
            ui: {
                currentCustomerId: null
            },
            lastOpen: null,
            overrideDone: []
        }),
        destroyed () {
            document.body.removeChild(this.$newEl)

            if (this.$taskCreatedEventSubscription) {
                this.$taskCreatedEventSubscription.unsubscribe()
            }

            if (this.$taskStatusChangedEventSubscription) {
                this.$taskStatusChangedEventSubscription.unsubscribe()
            }
        },
        ready () {
            this.lastOpen = localStorage.getItem("queue:last-open") || null

            if (!this.lastOpen) {
                this.lastOpen = moment().utc().format("YYYY-MM-DD HH:mm:ss")
                localStorage.setItem("queue:last-open", this.lastOpen)
            }

            this.$newEl = this.$appendTo(document.body).$el

            this.load()

            this.$taskCreatedEventSubscription = taskCreatedSub.subscribe(this.taskCreatedEvent)
            this.$taskStatusChangedEventSubscription = taskStatusChangedSub.subscribe(this.taskStatusChangedEvent)
        },
        methods: {
            taskButtonClicked () {

            },
            closeDropdown() {
                this.visible = false
            },
            taskCreatedEvent(a, b, c) {
                this.load()
            },
            taskStatusChangedEvent(a, b, c) {
                if (a && (a.status === 'DONE' || a.status === 'FAILED' || a.status === 'CANCELLED' || a.status === 'ABORTED')) {
                    this.overrideDone.push(a.id)
                    this.hasNewDone()
                } else if (a && (a.status === 'RUNNING' || a.status === 'WAITING')) {
                    this.hasNewRunning()
                }
            },
            taskStatusChanged(a) {
                if (a && (a.status === 'DONE' || a.status === 'FAILED' || a.status === 'CANCELLED' || a.status === 'ABORTED')) {
                    this.overrideDone.push(a.id)
                    this.hasNewDone()
                } else if (a && (a.status === 'RUNNING' || a.status === 'WAITING')) {
                    this.hasNewRunning()
                }
            },
            load (_e, _f) {
                if (this.loading) {
                    return
                }

                this.loading = true

                list().then((res) => {
                    const tasks = res.map((task) => {
                        if (this.overrideDone.indexOf(task.id) > -1) {
                            task.status = 'DONE'
                        }

                        return task
                    }).filter((task) => {
                        return !this.tasks.some(_ => _.id === task.id)
                    })

                    if (tasks.some(_ => _.status === 'RUNNING' || _.status === 'WAITING')) {
                        this.hasNewRunning()
                    }

                    this.tasks = tasks.concat(this.tasks)

                    this.loading = false
                })
            },
            buttonClicked (evt, button) {
                if (!button) {
                    evt.preventDefault()
                    return false;
                }

                if (button.isExplicitLink || evt.ctrlKey || evt.metaKey) {
                    return true
                }

                evt.preventDefault()

                switch (button.type) {
                    case 'PROPERTY':
                        this.$refs.propertyInfo.showById(button.propertyId)
                        break;
                    case 'CUSTOMER':
                        this.ui.currentCustomerId = button.customerId
                        setTimeout(() => {
                            this.$els.viewCustomerButton.click()
                        }, 100)
                        break;
                }

                return false
            },
            move (anchor) {
                this.$anchor = anchor

                const { top, right } = utils.getBounds(anchor)

                this.top = top + 21
                this.right = right
            },
            toggle (anchor) {
                if (this.visible) {
                    this.hide()
                } else {
                    this.show(anchor)
                }
            },
            show (anchor) {
                this.lastOpen = moment().utc().format("YYYY-MM-DD HH:mm:ss")
                localStorage.setItem("queue:last-open", this.lastOpen)

                this.hasNewChanged && this.hasNewChanged(false)

                this.move(anchor)
                this.visible = true

                this.load()

                this.createEvent()
            },
            hide () {
                this.visible = false

                this.destroyEvent()
            },
            createEvent () {
                this.destroyEvent()
                document.documentElement.addEventListener('click', this.bodyClicked)
                window.addEventListener('scroll', this.bodyScrolled, true)
            },
            destroyEvent () {
                document.documentElement.removeEventListener('click', this.bodyClicked)
                window.removeEventListener('scroll', this.bodyScrolled, true)
            },
            bodyScrolled (e) {
                if (!utils.isElementInViewport(this.$anchor)) {
                    this.hide()
                } else {
                    this.move(this.$anchor)
                }
            },
            bodyClicked (e) {
                const parent = this.$parent

                if (parent.constructor.name === 'NavbarTasks') {
                    if (!parent.$el.contains(e.target) && !this.$els.dropdown.contains(e.target)) {
                        this.hide()
                    }
                } else {
                    if (!this.$els.dropdown.contains(e.target)) {
                        this.hide()
                    }
                }
            },
            getStyle () {
                const style = {}

                style.top = this.top + 'px'
                style.right = this.right + 'px'

                // if (this.position === 'right') {
                //     style.right = 0
                //     style.left = 'auto'
                // } else {
                //     style.top = this.top
                //     style.left = this.left
                // }

                style.width = '400px'
                style.display = 'block'

                return style
            },
        },
        computed: {
            hasTasks () {
                return this.tasks.length > 0
            }
        },
        watch: {
            visible (newVal) {
                this.visibilityChanged(newVal)
            }
        }
    }
</script>


// WEBPACK FOOTER //
// Dropdown.vue?3631b7ca